import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import {
  calculateGradientColorStops,
  calculateLinearGradientDegree,
} from "../../../utils/colors.ts";

export function createLinearGradient(
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  paint: FigmaRestApi.GradientPaint,
): string {
  const { gradientHandlePositions, gradientStops } = paint;
  let value = "linear-gradient(";

  value += calculateLinearGradientDegree(gradientHandlePositions);

  value += calculateGradientColorStops(stylesFormatsConfig, gradientStops);

  value += ")";

  return value;
}
